module.exports = [{
  "ID": "0248",
  "CinemaNationalId": null,
  "Name": "Linden Boulevard Multiplex Cinemas ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "2784 Linden Boulevard",
  "Address2": "",
  "City": "Brooklyn, NY 11208",
  "Latitude": "40.669",
  "Longitude": "-73.8638",
  "ParkingInfo": "",
  "LoyaltyCode": "248",
  "IsGiftStore": false,
  "Description": "14 Screens\r\nStadium Seating\r\nHandicap Accessible\r\nReal D 3D\u00ae \r\nAssistive Listening Devices\r\nClosed Caption Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0272",
  "CinemaNationalId": null,
  "Name": "Showcase Cinemas Bridgeport",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "286 Canfield Avenue",
  "Address2": "",
  "City": "Bridgeport, CT 06605",
  "Latitude": "41.1612",
  "Longitude": "-73.2305",
  "ParkingInfo": "",
  "LoyaltyCode": "272",
  "IsGiftStore": false,
  "Description": "12 Screens\r\n7.1 Dolby Digital Sound\r\nReal D, 3D\r\nAssistive Listening Devices\r\nClosed Captioning Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0286",
  "CinemaNationalId": null,
  "Name": "Showcase Cinemas Worcester North",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "135 Brooks Street",
  "Address2": "",
  "City": "Worcester, MA 01606",
  "Latitude": "42.3164",
  "Longitude": "-71.8048",
  "ParkingInfo": "",
  "LoyaltyCode": "286",
  "IsGiftStore": false,
  "Description": "18 screens\r\nLobby Bar\r\nReal D 3D\r\nReserved Seating\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0338",
  "CinemaNationalId": null,
  "Name": "Showcase Cinemas Seekonk Route 6",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "100 Commerce Way",
  "Address2": "",
  "City": "Seekonk, MA 02771",
  "Latitude": "41.7967",
  "Longitude": "-71.3257",
  "ParkingInfo": "",
  "LoyaltyCode": "338",
  "IsGiftStore": false,
  "Description": "10 screens\r\nReal D 3D\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0354",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Lowell ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "32 Reiss Avenue",
  "Address2": "",
  "City": "Lowell, MA 01853",
  "Latitude": "42.6107",
  "Longitude": "-71.3252",
  "ParkingInfo": "",
  "LoyaltyCode": "354",
  "IsGiftStore": false,
  "Description": "14 Screens\r\nReserved Seating\r\nReclining Seats\r\nX Plus\r\nLobby Bar\r\nReal D 3D\r\nCC DVS",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0356",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Randolph",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "73 Mazzeo drive",
  "Address2": "",
  "City": "Randolph, MA 02368",
  "Latitude": "42.1632",
  "Longitude": "-71.064",
  "ParkingInfo": "",
  "LoyaltyCode": "356",
  "IsGiftStore": false,
  "Description": "16 Screens\r\n2 Lux Theaters\r\nMX4D\r\nImax\r\nLobby Bar\r\nReclining Seats\r\nReal D 3D\r\nCC DVS\r\nReserved Seating",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": true,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0366",
  "CinemaNationalId": null,
  "Name": "Edgewater Multiplex Cinemas",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "339 River Road",
  "Address2": "",
  "City": "Edgewater, NJ 07020",
  "Latitude": "40.8079",
  "Longitude": "-73.9902",
  "ParkingInfo": "",
  "LoyaltyCode": "366",
  "IsGiftStore": false,
  "Description": "16 Screens\r\nReal D 3D\r\nShowcase XPlus\r\nAssistive Listening Devices\r\nClosed Caption Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0368",
  "CinemaNationalId": null,
  "Name": "College Point Multiplex Cinemas ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "2855 Ulmer Street",
  "Address2": "",
  "City": "Whitestone, NY 11357",
  "Latitude": "40.7718",
  "Longitude": "-73.8374",
  "ParkingInfo": "",
  "LoyaltyCode": "368",
  "IsGiftStore": false,
  "Description": "12 Screens\r\nReclining Seats\r\nReal D 3D\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0378",
  "CinemaNationalId": null,
  "Name": "Greenburgh Multiplex Cinemas ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "320 Saw Mill River Road",
  "Address2": "",
  "City": "Elmsford, NY 10523",
  "Latitude": "41.0662",
  "Longitude": "-73.8148",
  "ParkingInfo": "",
  "LoyaltyCode": "378",
  "IsGiftStore": false,
  "Description": "10 Screens\r\nReal D 3D\r\nAssistive Listening Devices\r\nClosed Caption Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0388",
  "CinemaNationalId": null,
  "Name": "Jamaica Multiplex Cinemas",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "15902 Jamaica Avenue",
  "Address2": "",
  "City": "Jamaica, NY 11432",
  "Latitude": "40.7032",
  "Longitude": "-73.8019",
  "ParkingInfo": "",
  "LoyaltyCode": "388",
  "IsGiftStore": false,
  "Description": "15 Screens\r\nReal D 3D\r\nAssisted Listening Devices\r\nClosed Captioning Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0392",
  "CinemaNationalId": null,
  "Name": "Showcase Cinemas Warwick Mall",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "400 Bald Hill Road",
  "Address2": "",
  "City": "Warwick, RI 02886",
  "Latitude": "41.7244",
  "Longitude": "-71.4783",
  "ParkingInfo": "",
  "LoyaltyCode": "392",
  "IsGiftStore": false,
  "Description": "12 screens\r\nLobby Bar\r\nFood Court\r\nReal D 3D\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0396",
  "CinemaNationalId": null,
  "Name": "Island 16: Cinema de Lux ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "185 Morris Avenue",
  "Address2": "",
  "City": "Holtsville, NY 11742",
  "Latitude": "40.8169",
  "Longitude": "-73.0575",
  "ParkingInfo": "",
  "LoyaltyCode": "396",
  "IsGiftStore": false,
  "Description": "16 Screens\r\nReclining Seats\r\nReserved Seating\r\nChatters Bar & Grill\r\nReal D 3D \r\nShowcase XPlus\r\nMX4D\r\nAssistive Listening Devices\r\nClosed Captioning Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0416",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux City Center 15",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "19 Mamaroneck Ave",
  "Address2": "",
  "City": "White Plains, NY 10601",
  "Latitude": "41.0321",
  "Longitude": "-73.7678",
  "ParkingInfo": "",
  "LoyaltyCode": "416",
  "IsGiftStore": false,
  "Description": "15 Screens\r\nChatters Bar & Grill\r\nReal D 3D\r\nIMAX\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0424",
  "CinemaNationalId": null,
  "Name": "Blackstone Valley 14: Cinema de Lux",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "70 Worcester/Providence Tpke",
  "Address2": "",
  "City": "Millbury, MA 01527",
  "Latitude": "42.1998",
  "Longitude": "-71.7781",
  "ParkingInfo": "",
  "LoyaltyCode": "424",
  "IsGiftStore": false,
  "Description": "14 Screens\r\nChatters Bar & Grill\r\nReal D 3D \r\nShowcase XPlus\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0428",
  "CinemaNationalId": null,
  "Name": "Providence Place Cinemas 16 and IMAX",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "10 Providence Place",
  "Address2": "",
  "City": "Providence, RI 02903",
  "Latitude": "41.8267",
  "Longitude": "-71.4169",
  "ParkingInfo": "",
  "LoyaltyCode": "428",
  "IsGiftStore": false,
  "Description": "17 screens\r\nLobby Bar\r\nReal D 3D\r\nIMAX\r\nAssistive Listening Devices\r\nReserved Seating in IMAX",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0444",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux North Attleboro",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "840 South Washington St",
  "Address2": "",
  "City": "North Attleboro, MA 02760",
  "Latitude": "41.9541",
  "Longitude": "-71.344",
  "ParkingInfo": "",
  "LoyaltyCode": "444",
  "IsGiftStore": false,
  "Description": "12 screens\r\nLobby Bar\r\nReal D 3D\r\nReserved Seating\r\nAssistive Listening Devices\r\nRecliners",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0466",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Ridge Hill ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "59 Fitzgerald Street at Ridge Hill",
  "Address2": "",
  "City": "Yonkers, NY 10710",
  "Latitude": "40.9648",
  "Longitude": "-73.857",
  "ParkingInfo": "",
  "LoyaltyCode": "466",
  "IsGiftStore": false,
  "Description": "12 Screens\r\nStudio 3 Restaurant\r\nReal D 3D\r\nAssistive Listening Devices\r\nClosed Caption Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0468",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Patriot Place - Foxboro ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "24 Patriot Place",
  "Address2": "",
  "City": "Foxboro, MA 02035",
  "Latitude": "42.0946",
  "Longitude": "-71.2671",
  "ParkingInfo": "",
  "LoyaltyCode": "468",
  "IsGiftStore": false,
  "Description": "14 Screens\r\n4 Lux Screens\r\nStudio\r\nLobby Bar in Lux\r\nReal D 3D\r\nCC DVS",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0474",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Legacy Place - Dedham ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "670 Legacy Place",
  "Address2": "",
  "City": "Dedham, MA 02026",
  "Latitude": "42.2295",
  "Longitude": "-71.3166",
  "ParkingInfo": "",
  "LoyaltyCode": "474",
  "IsGiftStore": false,
  "Description": "15 Screens\r\n4 Lux Screens\r\nStudio\r\nLobby Bar in Lux\r\nReal D 3D\r\nCC DVS",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0484",
  "CinemaNationalId": null,
  "Name": "Showcase SuperLux - Chestnut Hill ",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "55 Boylston Street",
  "Address2": "",
  "City": "Chestnut Hill, MA 02467",
  "Latitude": "42.3212",
  "Longitude": "-71.1766",
  "ParkingInfo": "",
  "LoyaltyCode": "484",
  "IsGiftStore": false,
  "Description": "6 Screens\r\nDavio's\r\nLobby Bar\r\nAll Theaters Full Reclining Seats\r\nReal D 3D\r\nCC DVS\r\nReserved Seating",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0632",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Cross County",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "2 South Drive",
  "Address2": "",
  "City": "Yonkers, NY 10704",
  "Latitude": "41.3872",
  "Longitude": "-75.4957",
  "ParkingInfo": "",
  "LoyaltyCode": "632",
  "IsGiftStore": false,
  "Description": "10 Screens\r\nReclining Seats\r\nReserved Seats\r\nReal D 3D\r\nAssistive Listening Devices\r\nClosed Caption Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0634",
  "CinemaNationalId": "",
  "Name": "Fairfield Cinemas at Bullard Square",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "40 Black Rock Turnpike",
  "Address2": "",
  "City": "Fairfield, CT 06825",
  "Latitude": "41.1627",
  "Longitude": "-73.2299",
  "ParkingInfo": "",
  "LoyaltyCode": "634",
  "IsGiftStore": false,
  "Description": "9 screens\r\nReal D 3D\r\nAssistive Listening Devices\r\nClosed Captioning Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": "0634",
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0642",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Broadway",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "955 Broadway Mall",
  "Address2": "",
  "City": "Hicksville, NY 11801",
  "Latitude": "40.7729",
  "Longitude": "-73.5308",
  "ParkingInfo": "",
  "LoyaltyCode": "642",
  "IsGiftStore": false,
  "Description": "12 Screens\r\nReclining Seats\r\nReserved Seating\r\nReal D 3D\r\nAssistive Listening Devices\r\nClosed Captioning Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0644",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Farmingdale",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "1001 Broad Hollow Road",
  "Address2": "",
  "City": "Farmingdale, NY 11735",
  "Latitude": "40.7381",
  "Longitude": "-73.4237",
  "ParkingInfo": "",
  "LoyaltyCode": "644",
  "IsGiftStore": false,
  "Description": "14 Screens\r\nNathans & La Famiglia\r\nReal D 3D\r\nShowcase XPlus\r\nAssisted Listening Devices\r\nClosed Captioning Devices\r\nReclining seats\r\nReserved Seating",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0700",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Woburn",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "25 Middlesex Canal Parkway",
  "Address2": "",
  "City": "Woburn, MA 01801",
  "Latitude": "42.4753",
  "Longitude": "-71.1991",
  "ParkingInfo": "",
  "LoyaltyCode": "700",
  "IsGiftStore": false,
  "Description": "14 Screens\r\nLobby Bar\r\nReclining Seats\r\nReal D 3D\r\nCC DVS\r\nReserved Seating",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0710",
  "CinemaNationalId": null,
  "Name": "Springdale 18: Cinema de Lux",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "12064 Springfield Pike",
  "Address2": "",
  "City": "Springdale, OH 45246",
  "Latitude": "39.2985",
  "Longitude": "-84.4848",
  "ParkingInfo": "",
  "LoyaltyCode": "710",
  "IsGiftStore": false,
  "Description": "18 Screens\r\nChatters Bar & Grill\r\nReal D 3D\r\nIMAX\r\nAssistive Listening Devices ",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0880",
  "CinemaNationalId": null,
  "Name": "Showcase Cinemas Warwick, Quaker Lane",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "1200 Quaker Lane",
  "Address2": "",
  "City": "Warwick, RI 02886",
  "Latitude": "41.6639",
  "Longitude": "-71.4979",
  "ParkingInfo": "",
  "LoyaltyCode": "880",
  "IsGiftStore": false,
  "Description": "15 screens\r\nLobby Bar\r\nFood Court\r\nReal D 3D\r\nAssistive Listening Devices",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}, {
  "ID": "0890",
  "CinemaNationalId": null,
  "Name": "Showcase Cinema de Lux Revere",
  "NameAlt": "",
  "PhoneNumber": "",
  "EmailAddress": "",
  "Address1": "565 Squire Road",
  "Address2": "",
  "City": "Revere, MA 02151",
  "Latitude": "42.4309",
  "Longitude": "-71.0216",
  "ParkingInfo": "",
  "LoyaltyCode": "890",
  "IsGiftStore": false,
  "Description": "20 Screens\r\nChatters\r\nReclining Seats\r\nMX4d\r\nXplus\r\nReal D 3D\r\nCC DVS \r\nReserved Seating",
  "DescriptionAlt": null,
  "PublicTransport": "",
  "CurrencyCode": "USD",
  "AllowPrintAtHomeBookings": false,
  "AllowOnlineVoucherValidation": false,
  "DisplaySofaSeats": false,
  "TimeZoneId": "Eastern Standard Time",
  "HOPK": null,
  "NameTranslations": [],
  "DescriptionTranslations": [],
  "ParkingInfoTranslations": [],
  "PublicTransportTranslations": [],
  "TipsCompulsory": false,
  "TipPercentages": "0.00,0.00,0.00,0.00",
  "ServerName": null
}]